<template>
    <template v-for="(message, index) in messageStore.messages" :key="message.id">
        <v-snackbar
            :close-on-content-click="true"
            :color="getConfig(message.type).color"
            :model-value="message.show"
            :style="style(index) as any"
            :timeout="getConfig(message.type).timeout"
            location="bottom right"
            rounded="xl"
            variant="flat"
            position="absolute"
            @update:model-value="messageStore.clear(message.id)"
        >
            <p :class="getConfig(message.type).class">
                {{ message.text }}
            </p>
            <template v-slot:actions v-if="message.closeable === true">
                <v-btn :color="getConfig(message.type).btnColor" variant="text" location="top" @click="message.show = false">
                    <v-icon icon="mdi-close-circle" size="x-large"></v-icon>
                </v-btn>
            </template>
        </v-snackbar>
    </template>
</template>

<script lang="ts">
import {defineComponent} from "vue"
import {useKMessageStore} from "@/components/dds/KMessageStore/KMessageStore";

type Variants = 'success' | 'error' | 'warning' | 'info'
type ISnackConfig = {color: string; class: string, btnColor: string, timeout: string}
export default defineComponent({
    components: {},
    setup: function () {
        const messageStore = useKMessageStore();
        const snackConfig: Record<Variants, ISnackConfig> = {
            success: {
                color: 'kpmgSuccess-100',
                class: 'pa-3 text-kpmgSuccess-900',
                btnColor: 'kpmgSuccess-900',
                timeout: '2000'
            },
            error: {
                color: 'kpmgError-100',
                class: 'pa-3 text-kpmgError-900',
                btnColor: 'kpmgError-900',
                timeout: '8000'
            },
            warning: {
                color: 'kpmgWarning-100',
                class: 'pa-3 text-kpmgWarning-900',
                btnColor: 'kpmgWarning-900',
                timeout: '6000'
            },
            info: {
                color: 'kpmgTertiary-100',
                class: 'pa-3 text-kpmgTertiary-900',
                btnColor: 'kpmgTertiary-900',
                timeout: '2000'
            },
        }
        const style = (index: number): object => {
            return {
                marginBottom: (1 + (5 * (messageStore.messages.length - 1 - index))) + 'rem',
                zIndex: 5000
            }
        }
        const getConfig = (messageType: string): ISnackConfig => {
            if (['success', 'error', 'warning', 'info'].includes(messageType)) {
                return snackConfig[messageType];
            }
            return snackConfig['info'];
        }

        return {
            // const
            messageStore,
            // => f
            getConfig,
            style,
        }
    },
})
</script>

<!--<style lang="scss" scoped />-->
